import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { ErrorMessages } from "./enums";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function toKebabCase(str: string): string {
  return str.toLowerCase().replace(/\s+/g, "-");
}

export function fromKebabCase(str: string): string {
  return str
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function toTitleCase(str: string): string {
  return str
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function toSlug(str: string): string {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-");
}

export function removeEmojis(str: string): string {
  return str.replace(
    /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{2B50}\u{2B55}]/gu,
    ""
  );
}

export function translateSupabaseError(errorMessage: string): string {
  switch (errorMessage) {
    case "To signup, please provide your email":
      return ErrorMessages.ProvideEmail;
    case "Signup requires a valid password":
      return ErrorMessages.ValidPasswordRequired;
    case "User already registered":
      return ErrorMessages.UserAlreadyRegistered;
    case "Only an email address or phone number should be provided on signup.":
      return ErrorMessages.OnlyEmailOrPhone;
    case "Signups not allowed for this instance":
      return ErrorMessages.SignupsNotAllowed;
    case "Email signups are disabled":
      return ErrorMessages.EmailSignupsDisabled;
    case "Email link is invalid or has expired":
      return ErrorMessages.EmailLinkInvalidOrExpired;
    case "Token has expired or is invalid":
      return ErrorMessages.TokenExpiredOrInvalid;
    case "The new email address provided is invalid":
      return ErrorMessages.InvalidNewEmail;
    case "Password should be at least 6 characters.":
      return ErrorMessages.PasswordTooShort;
    case "Invalid login credentials":
      return ErrorMessages.InvalidCredentials;
    case "Email not confirmed":
      return ErrorMessages.EmailNotConfirmed;
    case "New password should be different from the old password.":
      return ErrorMessages.NewPasswordShouldBeDifferentFromOldPassword;
    default:
      return "Error desconocido";
  }
}

export const getValueFromEnum = (key: string, enumProp: any): string => {
  return enumProp[key] || key;
};
